// UI
import PurchaseOrderSupplierSelect from './PurchaseOrderSupplierSelect'
import PurchaseOrderLinesEdit from './PurchaseOrderLinesEdit'
import Box from '@/components/ui/Box'

// Mantine
import { Button, TextInput } from '@mantine/core'

// React
import { useState } from 'react'

// Location
import LocationSelect from '@/components/ui/LocationSelect'

export default function PurchaseOrderCreateEdit({
    purchaseOrder,
    handlers,
    closeEditMode,
    isSaving,
}) {
    const onFormSubbmit = async () => {
        if (!checkValidity()) {
            return
        }

        const { id, mode } = await handlers.save()

        if (closeEditMode) {
            closeEditMode()
        }

        // If it has just been created, redirect to the display page
        if (mode === 'create') {
            window.location.href = `/purchase_orders/${id}`
        }
    }

    const [errors, setErrors] = useState({})

    // Check validity of the form
    const checkValidity = () => {
        const errors = {}

        if (!purchaseOrder.name) {
            errors.name = 'Le nom est obligatoire'
        }

        if (!purchaseOrder.location_id) {
            errors.location = 'Le lieu de réception est obligatoire'
        }

        if (!purchaseOrder.supplier) {
            errors.supplier = 'Le fournisseur est obligatoire'
        }

        // Check if there is at least one line
        if (!purchaseOrder.lines || purchaseOrder.lines.length === 0) {
            errors.lines = 'Il faut au moins une ligne'
        }

        // Check if all lines are valid
        if (purchaseOrder.lines?.some((line) => !line.reception_at)) {
            errors.lines = 'Il faut une date de réception pour chaque ligne'
        }

        setErrors(errors)

        // Return if the form is valid
        return Object.values(errors).length === 0
    }

    return (
        <div className="p-5 flex flex-col w-full max-w-[800px] mx-auto">
            <Box
                title={
                    purchaseOrder?.id
                        ? 'Modifier le bon de commande'
                        : 'Créer un bon de commande'
                }
            >
                <div className="flex flex-col mt-5 gap-5 w-full max-w-[800px]">
                    <TextInput
                        label="Nom"
                        description="Un nom pour reconnaitre d'un coup d'oeil le contenu du bon de commande"
                        value={purchaseOrder.name}
                        onChange={handlers.onNameChange}
                        error={errors.name}
                    />

                    <LocationSelect
                        label="Lieu de réception"
                        value={purchaseOrder.location_id.toString()}
                        onChange={handlers.onLocationIdChange}
                        error={errors.location}
                    />

                    <PurchaseOrderSupplierSelect
                        value={purchaseOrder.supplier}
                        onChange={handlers.onSupplierChange}
                        error={errors.supplier}
                    />

                    <TextInput
                        label="Référence du bon de commande"
                        placeholder="Référence du bon de commande du fournisseur"
                        value={purchaseOrder.reference}
                        onChange={handlers.onReferenceChange}
                    />

                    <PurchaseOrderLinesEdit
                        purchaseOrder={purchaseOrder}
                        handlers={handlers}
                    />

                    {errors.lines && (
                        <div className="text-red-500 text-sm">
                            {errors.lines}
                        </div>
                    )}

                    <div className="mx-auto flex gap-2">
                        {closeEditMode && (
                            <Button variant="default" onClick={closeEditMode}>
                                Annuler
                            </Button>
                        )}

                        <Button onClick={onFormSubbmit} loading={isSaving}>
                            {purchaseOrder?.id
                                ? 'Modifier le bon de commande'
                                : 'Créer un bon de commande'}
                        </Button>
                    </div>
                </div>
            </Box>
        </div>
    )
}
